// CustomerForm.js
import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Button, MenuItem, Select, FormControl, InputLabel, Typography, Paper, FormLabel,
    RadioGroup, FormControlLabel, FormHelperText, Radio, CircularProgress, Tooltip, Chip, Grid,
    Autocomplete,
    Alert
} from '@mui/material';
import { audioService } from '../../services/audioService';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import IconButton from '@mui/material/IconButton';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Divider from '@mui/material/Divider';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

import customerService from '../../services/customerService';
import { countryService } from '../../services/countryService';
import { regionService } from '../../services/regionService';
import { provinceService } from '../../services/provinceService';
import { communeService } from '../../services/communeService';
import { BranchService } from '../../services/branchService';
import { SearchService } from '../../services/SearchService';
import { categoriaService } from '../../services/categoriaService';
import { genereService } from '../../services/genereService';
import { tipoClienteService } from '../../services/tipoClienteService';
import { claveClienteService } from '../../services/claveService';
import { estadoCivilService } from '../../services/estadoCivilService';
import Swal from 'sweetalert2'

import { useSelector, useDispatch } from 'react-redux';
import { setCustomer, setCustomerFormatted, setTab, setSucursales } from '../../Redux/TabDucks';
import { useJsApiLoader, Autocomplete as GoogleMapsAutocomplete } from '@react-google-maps/api';
import { SkipNext } from '@mui/icons-material';
import { use } from 'react';

const libraries = ['places'];

//import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

// Configura dayjs para usar el locale en español
dayjs.locale('es');
const today = new Date();

const CustomerForm = () => {
    const dispatch = useDispatch();
    const customerData = useSelector((store) => store.tab.customer);
    const customerFormatted = useSelector((store) => store.tab.customerFormatted);
    const contractFull = useSelector((store) => store.tab.contractFull);
    const contract = useSelector((store) => store.tab.contract);
    const _tab = useSelector((store) => store.tab);

    // Estados para manejar los datos del formulario.
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [regiones, setRegiones] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [selectedProvincia, setSelectedProvincia] = useState('');
    const [comunas, setComunas] = useState([]);
    const [selectedComuna, setSelectedComuna] = useState('');
    const [sucursales, setSucursal] = useState([]);
    const [categorias, setCategoria] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState('');
    const [selectedSucursal, setSelectedSucursal] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [causas, setCausas] = useState([]);
    const [tiposCliente, setTipoCliente] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(1);
    const [selectedClave, setSelectedClave] = useState(1);
    const [clavesCliente, setClaveCliente] = useState([]);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [generos, setGenero] = useState([]);
    const [estadoCiviles, setEstadoCivil] = useState([]);
    const [validacionMatrimonio, setvalidacionMatrimonio] = useState([]);
    const [loadingEstadoCivil, setLoadingEstadoCivil] = useState(false);
    const [estadoCivilList, setEstadoCivilList] = useState();
    const [selectedNivelEducacional, setSelectedNivelEducacion] = useState('');
    const [dealHubspotIds, setDealHubspotIds] = useState([]);

    //comunas api de google
    const [autocomplete, setAutocomplete] = useState(null);
    const [direccion, setDireccion] = useState('');

    const [selectedGenero, setSelectedGenero] = useState('');
    const [selectedEstadoCivil, setSelectedEstadoCivil] = useState("");
    const [selectedDealHubspotId, setSelectedDealHubspotId] = useState(null);
    const [infoMessage, setInfoMessage] = useState(null);

    const [customer, setCustomer] = useState({
        createDate: '',
        hubspotID: '',
        Identifier: '',
        rut: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        //fechaNacimiento:'',
        fechaNacimientoSinVerificar: '',
        address: '',
        country: '',
        countries: '',
        region: '',
        provincia: '',
        sucursal: '',
        categoria: '',
        tipoCliente: '',
        claveUnica: '',
        observations: '',
        pymeData: '',
        generos: '',
        estadoCivil: '',
        tiposCliente: '',
        rutPyme: '',
        nombrePyme: '',
        nivelEducacional: '',
        dealHubspotId: '',
    });

    //
    const [allowUpdate, setAllowUpdate] = useState(true);

    const fetchCountry = async () => {
        try {
            setLoading(true);
            const data = await countryService.getAllCountry();
            setCountries(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };
    const fetchRegion = async () => {
        try {
            setLoading(true);
            const data = await regionService.getAllRegion();
            setRegiones(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };
    const fetchProvincias = async () => {
        try {
            setLoading(true);
            const data = await provinceService.getAllProvinces();
            setProvincias(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las provincias');
            setLoading(false);
        }
    };
    const fetchComunas = async (idProvidence) => {
        try {
            setLoading(true);
            const data = await communeService.getAllCommunes();
            setComunas(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };
    const fetchSucursales = async () => {
        try {
            setLoading(true);
            const data = await BranchService.getAllBrach();
            setSucursal(data);
            dispatch(setSucursales(data));
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };
    const fetchcategoria = async () => {
        try {
            setLoading(true);
            const data = await categoriaService.getCategoria();
            setCategoria(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las Categoria');
            setLoading(false);
        }
    };

    const fetchGenero = async () => {
        try {
            setLoading(true);
            const data = await genereService.getGenere();
            setGenero(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los Genero');
            setLoading(false);
        }

    };

    const fetchEstadoCivil = async () => {
        try {
            setLoading(true);
            const data = await estadoCivilService.getEstadoCivil();
            setEstadoCivil(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar civil');
            setLoading(false);
        }

    };

    const civilStatusMapping = {
        "Soltero": 1,
        "Casado": 2,
        "Divorciado": 3,
        "Viudo": 4,
        "Separado": 5,
        "Conviviente": 6,
    };


    const fetchTipoCliente = async () => {
        try {
            setLoading(true);
            const data = await tipoClienteService.getTipoCliente();
            setTipoCliente(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los Tipo de Cliente');
            setLoading(false);
        }

    };
    const fetchClaveCliente = async () => {
        try {
            setLoading(true);
            const data = await claveClienteService.getClaveCliente();
            setClaveCliente(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los Clave unica');
            setLoading(false);
        }

    };

    const fetchRegistroCivil = async (rut) => {
        try {
            setLoading(true);  // Activar el loading
            setInfoMessage("Validando la información en el Registro Civil...");  // Mostrar el mensaje

            // Realiza la consulta a la API
            const response = await estadoCivilService.validacionMatrimonio(rut);

            // Verifica si la respuesta es válida
            if (response?.Resultado?.Data?.Estado) {
                const estadoCivil = response.Resultado.Data.Estado;
                setEstadoCivilList(estadoCivil);
                // Mapea el estado civil a su ID correspondiente
                const estadoCivilId = civilStatusMapping[estadoCivil] || ""; // Mapeo básico con un valor por defecto

                if (estadoCivil === "Rut Erroneo" || estadoCivil === "Sin resultado en chile") {
                    setError('Error en el Registro Civil: No se encontró el estado civil.');
                    // Si hay error en el Registro Civil, carga manual de opciones
                    await fetchEstadoCivil(); // Carga manual de opciones de estado civil
                } else {
                    //setSelectedEstadoCivil(estadoCivilId);  // Precarga el estado civil en el Select
                    //setCustomer(prevState => ({
                    //    ...prevState,
                    //    estadoCivil: estadoCivilId,  // Asigna el estado civil al cliente
                    //}));
                }
            } else {
                console.error("No se encontró estado civil en la respuesta.");
                setError("No se encontró estado civil en la respuesta.");
                await fetchEstadoCivil(); // Carga manual de opciones
            }
        } catch (err) {
            console.error('Error al consultar Registro Civil:', err);
            setError('Error al consultar Registro Civil');
            await fetchEstadoCivil(); // Carga manual de opciones si ocurre un error
        } finally {
            setLoading(false);  // Detiene la carga
        }
    };

    const mapCustomerData = (customerData) => {
        return {
            createDate: customerData.properties.createDate || '',
            hubspotID: customerData.id || '',
            Identifier: customerData.properties.id || '',
            rut: customerData.properties.rut || '',
            firstName: customerData.properties.firstName || '',
            lastName: customerData.properties.lastName || '',
            email: customerData.properties.email || '',
            phone: customerData.properties.phone || '',
            fechaNacimientoSinVerificar: customer?.fechaNacimientoSinVerificar || customerData.properties.fecha_nacimiento__sin_verificar_ || '',
            address: customerData.properties.address || '',
            country: customerData.properties.city || '', // Assuming 'city' corresponds to 'country'
            countries: '', // Placeholder, not mapped
            region: '', // Placeholder, not mapped
            provincia: '', // Placeholder, not mapped
            sucursal: '', // Placeholder, not mapped
            categoria: '', // Placeholder, not mapped
            tipoCliente: '', // Placeholder, not mapped
            claveUnica: '', // Placeholder, not mapped
            observations: '', // Placeholder, not mapped
            pymeData: '', // Placeholder, not mapped
            generos: customerData.properties.gender || '',
            estadoCivil: customerData.properties.marital_status || '',
            tiposCliente: '', // Placeholder, not mapped
            rutPyme: '', // Placeholder, not mapped
            nombrePyme: '', // Placeholder, not mapped
            nivelEducacional: '', // Placeholder, not mapped
        };
    };

    const [finiquitado, setFiniquitado] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [bloquearAcciones, setBloquearAcciones] = useState(false);

    useEffect(() => {
        if (_tab.contractFull?.cancel == true) {
            setCancelado(true)
            setBloquearAcciones(true)
        }
        if (_tab.contractFull?.finiquitado == true) {
            setFiniquitado(true)
            setBloquearAcciones(true)
        }
    }, [_tab])

    useEffect(() => {
        if (customerFormatted && customerFormatted.rut) {
            fetchCountry();
            fetchRegion();
            fetchProvincias();
            fetchComunas();
            fetchSucursales();
            fetchGenero();
            fetchTipoCliente();
            fetchClaveCliente();
            fetchEstadoCivil();
            //fetchRegistroCivil(customerFormatted.rut);

            setCustomer(customerFormatted);
            setDireccion(customerFormatted.address ?? '');
            setSelectedCountry(customerFormatted.country ?? 1);

            setSelectedProvincia(customerFormatted.provincia ?? '');
            setSelectedComuna(customerFormatted.comuna ?? '');
            setSelectedSucursal(customerFormatted.sucursal ?? '');
            setSelectedTipo(customerFormatted.tipoClienteSeleccionado ?? 1);
            setSelectedClave(customerFormatted.claveUnica == null ? 1 : 2)
            setSelectedGenero(customerFormatted.genero ?? '');
            setSelectedEstadoCivil(customerFormatted.estadoCivil ?? '');
        } else if (customerData && customerData.properties && customerData.properties.rut) {
            const rut = customerData.properties.rut;
            fetchCountry();
            fetchRegion();
            fetchProvincias();
            fetchComunas();
            fetchSucursales();
            fetchGenero();
            fetchTipoCliente();
            fetchClaveCliente();
            fetchEstadoCivil();
            fetchRegistroCivil(rut);

            const mappedCustomer = mapCustomerData(customerData);
            setCustomer(mappedCustomer);

            setSelectedCountry(customerData.properties?.country ?? '');
            setSelectedRegion(customerData.properties?.region ?? '');
            setSelectedProvincia(customerData.properties?.provincia ?? '');
            setSelectedComuna(customerData.properties?.comuna ?? '');
            setSelectedSucursal(customerData.properties?.sucursal ?? '');
            setSelectedTipo(customerData.properties?.tipoCliente ?? 1);
            setSelectedClave(customerData.properties?.selectedClave ?? 1);
            setSelectedGenero(customerData.properties?.genero ?? '');
            setSelectedEstadoCivil(customerData.properties?.estadoCivil ?? '');
        }

        if (customerFormatted.rut) {
            /*
            var customerGc = await customerService.obtieneCliente(customerFormatted.rut)
            */
        }
    }, [customerData, customerFormatted]);

    useEffect(() => {
        setDireccion(customerFormatted.address ?? '');
        setSelectedCountry(customerFormatted.country ?? '');
        setSelectedRegion(customerFormatted.region ?? '');
        setSelectedProvincia(customerFormatted.provincia ?? '');
        setSelectedComuna(customerFormatted.comuna ?? '');
        setSelectedSucursal(customerFormatted.sucursal ?? '');
        setSelectedTipo(customerFormatted.rutPyme == null ? 1 : 2);
        setSelectedClave(customerFormatted.selectedClave ?? 1);
        setSelectedGenero(customerFormatted.genero ?? '');
        setSelectedEstadoCivil(customerFormatted.estadoCivil ?? '');
    }, [customerFormatted]);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: window.GOOGLE_API_KEY,
        libraries, // Cargamos la biblioteca de places
    });

    function removeAccents(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function includesIgnoreAccents(str, search) {
        return removeAccents(str).toLowerCase().includes(removeAccents(search).toLowerCase());
    }
    // Manejo de selección de dirección en el Autocomplete
    const handlePlaceChanged = (e) => {
        if (autocomplete) {
            const place = autocomplete.getPlace();

            // Actualiza la dirección completa
            setDireccion(place.formatted_address);
            handleChange({ target: { name: 'address', value: place.formatted_address } });


            // Extraer datos de región, provincia y comuna
            const addressComponents = place.address_components;

            const regionData = addressComponents.find((comp) =>
                comp.types.includes('administrative_area_level_1')
            );
            const provinciaData = addressComponents.find((comp) =>
                comp.types.includes('administrative_area_level_2')
            );
            const comunaData = addressComponents.find((comp) =>
                comp.types.includes('locality')
            );

            if (regionData) {
                const sRegion = regiones.find((r) => r.description.includes(regionData.long_name));
                setSelectedRegion(sRegion.id);
                handleRegionChange(e, sRegion);

            }
            if (provinciaData) {
                const sProvincia = provincias.find((p) => includesIgnoreAccents(p.description, provinciaData.long_name));
                setSelectedProvincia(sProvincia.id);
                handleProvinciaChange(e, sProvincia);
            }
            if (comunaData) {
                const sComuna = comunas.find((c) => includesIgnoreAccents(c.description, comunaData.long_name));
                setSelectedComuna(sComuna.id);
                handleComunaChange(e, sComuna);
                //seleccionar sucursal de acuerdo a la comuna
                const sBranch = sucursales.find((s) => sComuna.idBranch == s.id);
                setSelectedSucursal(sBranch.id)
                handleSucursalChange(e, sBranch);
            }

        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomer(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCountryChange = (event, newValue) => {
        const countryId = newValue ? newValue.id : '';
        setSelectedCountry(countryId);
        setCustomer(prevState => ({
            ...prevState,
            country: countryId
        }));
    };

    const handleSucursalChange = (event, newValue) => {
        const idBranch = newValue ? newValue.id : '';
        setSelectedSucursal(idBranch);
        setCustomer(prevState => ({
            ...prevState,
            sucursal: idBranch
        }));
    };
    const handleRegionChange = (event, newValue) => {
        const idRegion = newValue ? newValue.id : '';
        setSelectedRegion(idRegion);
        setCustomer(prevState => ({
            ...prevState,
            region: idRegion
        }));
    };
    const handleProvinciaChange = (event, newValue) => {
        const idProvidence = newValue ? newValue.id : '';
        setSelectedProvincia(idProvidence);
        setCustomer(prevState => ({
            ...prevState,
            provincia: idProvidence

        }));
    };

    const handleComunaChange = (event, newValue) => {
        const comunaId = newValue ? newValue.id : '';
        setSelectedComuna(comunaId);
        setCustomer(prevState => ({
            ...prevState,
            comuna: comunaId

        }));


    };
    const handleGeneroChange = (event, newValue) => {
        const generoId = newValue ? newValue.id : '';
        setSelectedGenero(generoId);
        setCustomer(prevState => ({
            ...prevState,
            genero: generoId
        }));
    };

    const handleEstadoCivil = (event, newValue) => {
        const estadoCivilId = newValue ? newValue.id : '';
        setSelectedEstadoCivil(estadoCivilId);
        setCustomer(prevState => ({
            ...prevState,
            estadoCivil: estadoCivilId
        }));
    };

    const handleDealHubspotId = async (event, newValue) => {
        const _dealHubspotId = newValue ? newValue.id : ''
        setSelectedDealHubspotId(_dealHubspotId);
        setCustomer(prevState => ({
            ...prevState,
            dealHubspotId: _dealHubspotId
        }));

        if (_dealHubspotId && _tab.interview && _tab.interview.id)
            var response = await customerService.sendHubspotDealId({ dealHubspotId: _dealHubspotId, interviewId: _tab.interview.id })
    }

    const handleTipoClienteChange = (event) => {
        const tc = Number(event.target.value); // Convertimos a número si es necesario
        setSelectedTipo(tc);

        setCustomer(prevState => ({
            ...prevState,
            tipoClienteSeleccionado: tc,
        }));
    };

    const handleClaveClienteChange = (event) => {
        const cc = Number(event.target.value);
        //   setClaveCliente(cc);

        setSelectedClave(cc);
        setCustomer(prevState => ({
            ...prevState,
            selectedClave: cc, // Asegúrate de usar el nombre correcto de la propiedad en tu estado
        }));

    };



    const handlePymeRutChange = (event) => {
        setCustomer((prevData) => ({
            ...prevData,
            rutPyme: event.target.value,
        }));
    }


    const handlePymeNomChange = (event) => {
        setCustomer((prevData) => ({
            ...prevData,
            nombrePyme: event.target.value,

        }));
    }

    const handleCombinedOperation = async (e) => {
        e.preventDefault();
        var customData = customer;
        customData.address = direccion
        
        try {
            const contractId = contractFull.contractId ?? null
            const InterviewId = _tab.interview.id ?? null
            
            


            if (!checkForm(customData))
                return;

            // Luego, crea el usuario en el generador de contratos
            const customerResponse = await customerService.createCustomerService(customData.hubspotID, customData, contractId, InterviewId);
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Generador de Contratos Actualización Exitosa",
                showConfirmButton: false,
                timer: 1500
            });

            //Navega a la página de Informacion complementaria 
            customData.id = customerResponse.id

            // navigate('/RegistroPage',{ state: { customer } })
            dispatch(setTab("2"));
            dispatch(setCustomerFormatted(customData))
            //zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz
            //onChangeIndex(e,"3",customer);
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Error en la operación. Intente nuevamente más tarde",
                showConfirmButton: false,
                timer: 1500
            });
            console.error('Error en la operación:', error);
        }
    }

    const checkForm = (customer) => {
        var message = "";

        const camposRequeridos = [
            { campo: 'rut', nombre: 'Rut' },
            { campo: 'firstName', nombre: 'Nombre' },
            { campo: 'lastName', nombre: 'Apellido' },
            { campo: 'email', nombre: 'Correo' },
            { campo: 'phone', nombre: 'Teléfono' },
            { campo: 'fechaNacimientoSinVerificar', nombre: 'Fecha de Nacimiento' },
            { campo: 'genero', nombre: 'Género' },
            { campo: 'estadoCivil', nombre: 'Estado civil' },
            { campo: 'address', nombre: 'Dirección' },
            { campo: 'country', nombre: 'País' },
            { campo: 'region', nombre: 'Región' },
            { campo: 'provincia', nombre: 'Provincia' },
            { campo: 'comuna', nombre: 'Comuna' },
            { campo: 'sucursal', nombre: 'Sucursal' },
        ];

        camposRequeridos.forEach(({ campo, nombre }) => {
            if (!customer[campo]) {
                message += `${nombre} \n`;
            }
        });

        Swal.fire({
            position: "center",
            icon: "warning",
            title: "Faltan los siguientes datos \n " + message,
            showConfirmButton: false
        });


        return message.length == 0 ? true : false;
    }


    useEffect(() => {
        if (contractFull.dealHubspotId) {
            setSelectedDealHubspotId(contractFull.dealHubspotId)
        }
        if (contractFull && contractFull.negocios && contractFull.negocios.length > 0) {
            var negocio = contractFull.negocios[0]
            if (negocio.urlFE) {
                setAllowUpdate(false)
            }
            else if (negocio.urlFEXL) {
                setAllowUpdate(false)
            } else {
                setAllowUpdate(true)
            }
        } else {
            setAllowUpdate(true)
        }
    }, [contractFull]);

    useEffect(() => {
        const auxFunction = async (HubspotID) => {
            const dataHb = await audioService.getHubspotDealsContact(HubspotID);
            // Step 2: Get Deal ID
            var dealIds = []
            if (dataHb.associations && dataHb.associations.deals && dataHb.associations.deals.results && dataHb.associations.deals.results.length > 0) {
                var dealIds = dataHb.associations.deals.results
                setDealHubspotIds(dealIds.map(item => ({ id: item.id, name: item.id })))
            }
            if (dealIds.length == 0)
                alert("no tiene negocios identificados")
        }
        var HubspotID = customerData.id
        if (customerData && customerData.hubspotID && customerData.hubspotID != '')
            HubspotID = customerData.hubspotID
        else if (customerFormatted && customerFormatted.hubspotID && customerFormatted.hubspotID != '')
            HubspotID = customerFormatted.hubspotID

        if (HubspotID && HubspotID != '') {
            auxFunction(HubspotID)
        }
        //customerFormatted
    }, [customerData, customerFormatted])

    useEffect(() => {
        if (_tab.interview.dealHubspotId)
            setSelectedDealHubspotId(_tab.interview.dealHubspotId);
    }, [_tab.interview]);

    if (!isLoaded) { return <div>Cargando...</div> }

    return (
        <Paper elevation={6} sx={{ p: 4, mt: 4 }}>
            <Alert severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
            <Alert severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>
            <Box component="form" noValidate autoComplete="off" >
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        <Divider sx={{ mt: 3, mb: 3 }}>DATOS PERSONALES</Divider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="hubspotID"
                            label="Hubspot ID"
                            name="hubspotID"
                            value={customerData?.id || customer?.hubspotID || ""}
                            onChange={handleChange}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="dealId"
                            options={dealHubspotIds}
                            getOptionLabel={(option) => option.name || ''}
                            value={dealHubspotIds.find((ec) => ec.id === selectedDealHubspotId) || null}
                            onChange={handleDealHubspotId}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Codigo de negocio Hubspot"
                                    fullWidth
                                    required
                                    helperText={!selectedDealHubspotId && (<span style={{ color: 'red' }}> (Campo obligatorio) </span>)}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            disabled={bloquearAcciones/*!allowUpdate*/}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="rut"
                            label="Rut Cliente o Pasaporte"
                            name="rut"
                            helperText={
                                <span style={{ color: 'red' }}>
                                    (Campo obligatorio)
                                </span>
                            }
                            value={customerData?.properties?.rut || customer.identifier || ""}
                            onChange={handleChange}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            id="firstName"
                            label="Nombre Cliente"
                            name="firstName"
                            helperText={
                                <span style={{ color: 'red' }}>
                                    (Campo obligatorio)
                                </span>
                            }
                            //value={customerData?.properties?.firstName || ""}
                            value={customer.firstName || ''}
                            onChange={(e) => handleChange(e)}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="lastName"
                            label="Apellido Cliente"
                            name="lastName"
                            helperText={
                                <span style={{ color: 'red' }}>
                                    (Campo obligatorio)
                                </span>
                            }
                            //  value={customerData?.properties?.lastName || customer.lastName || ''}
                            value={customer.lastName || ''}
                            onChange={(e) => handleChange(e)}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="email"
                            label="Email"
                            name="email"
                            helperText={
                                <span style={{ color: 'red' }}>
                                    (Campo obligatorio)
                                </span>
                            }
                            //value={customerData?.properties?.email || ""}
                            value={customer.email || ''}
                            onChange={(e) => handleChange(e)}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            id="phone"
                            label="Telefono"
                            name="phone"
                            helperText={
                                <span style={{ color: 'red' }}>
                                    (Campo obligatorio)
                                </span>
                            }
                            //value={customerData?.properties?.phone || ""}
                            value={customer.phone || ''}
                            onChange={(e) => handleChange(e)}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <Grid container spacing={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                <Grid item xs={12} sm={6} hidden={customerData.properties?.createDate ? false : true}>
                                    <DatePicker
                                        required
                                        id="createDate"
                                        label="Fecha Contacto"
                                        name="createDate"
                                        value={
                                            customerData?.properties?.createDate
                                                ? dayjs(customerData.properties.createDate)
                                                : null
                                        }
                                        onChange={(newValue) => {
                                            handleChange({ target: { name: 'createDate', value: newValue } });
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                        disabled={!allowUpdate}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}  >
                                    <DatePicker
                                        required
                                        id="fechaNacimientoSinVerificar"
                                        label="Fecha Nacimiento"
                                        name="fechaNacimientoSinVerificar"
                                        helperText={
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        }
                                        value={customer?.fechaNacimientoSinVerificar != null ?
                                            dayjs(customer.fechaNacimientoSinVerificar) :
                                            (customerData?.properties?.fecha_nacimiento__sin_verificar_
                                                ? dayjs(customerData.properties.fecha_nacimiento__sin_verificar_)
                                                : null)}
                                        onChange={(newValue) => {
                                            handleChange({ target: { name: 'fechaNacimientoSinVerificar', value: newValue } });
                                        }}
                                        renderInput={(params) => <TextField {...params} />}

                                        disabled={!allowUpdate}
                                    />
                                    <FormHelperText>      <span style={{ color: 'red' }}>
                                        (Campo obligatorio)
                                    </span></FormHelperText>
                                </Grid>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="genero"
                            options={generos}
                            getOptionLabel={(option) => option.description || ''}
                            value={generos.find((genero) => genero.id === selectedGenero) || null}
                            onChange={handleGeneroChange} // Usamos la función adaptada
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Género Cliente"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedGenero && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={3}>
                            <Grid item sm={8}>
                                {/* Selector de Estado Civil */}
                                {loading ? (
                                    <>
                                        <CircularProgress size={24} />
                                        {infoMessage && <Typography variant="body2">{infoMessage}</Typography>}
                                    </>
                                ) : (
                                    <Autocomplete
                                        id="estadoCivil"
                                        options={estadoCiviles}
                                        getOptionLabel={(option) => option.name || ''}
                                        value={estadoCiviles.find((ec) => ec.id === selectedEstadoCivil) || null}
                                        onChange={handleEstadoCivil}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Estado Civil"
                                                fullWidth
                                                required
                                                helperText={
                                                    !selectedEstadoCivil && (
                                                        <span style={{ color: 'red' }}>
                                                            (Campo obligatorio)
                                                        </span>
                                                    )
                                                }
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loading ? <CircularProgress size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                        disabled={!allowUpdate}
                                    />
                                )}
                            </Grid>

                            {/* Botón de Validación 
                            <Grid item sm={4}>
                                <Tooltip title="Consulta Registro Civil">
                                    <IconButton color="primary"
                                        variant="contained"
                                        size='large'
                                        onClick={fetchRegistroCivil}
                                    >
                                        <PersonSearchIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            */}

                            {/* Resultado como Tag después de la validación */}
                            {/*estadoCivilList ? <>
                                <Grid item xs={12} style={{ marginTop: '8px' }}>
                                    <Chip label={`Estado Civil: ${estadoCivilList}xxxx`} color="primary" />
                                </Grid>
                            </>
                                :
                                <>
                                    <Grid item xs={4} style={{ marginTop: '8px' }}>
                                        <Chip label={`Estado Civil: buscando...xxxx`} color="primary" />
                                    </Grid>
                                    <Grid item xs={2} style={{ marginTop: '12px' }}> <CircularProgress size={20} /></Grid>
                                </>
                            */}
                        </Grid>
                    </Grid>


                    <Grid item xs={12} sm={6}>
                        <GoogleMapsAutocomplete
                            onLoad={(autocompleteInstance) => setAutocomplete(autocompleteInstance)}
                            onPlaceChanged={handlePlaceChanged}
                            options={{ componentRestrictions: { country: 'cl' } }}
                        >
                            <TextField
                                label="Dirección"
                                fullWidth
                                variant="outlined"
                                value={direccion || customer.address || ""}
                                onChange={(e) => setDireccion(e.target.value)}
                                placeholder="Ingresa tu dirección"
                                sx={{ mb: 3 }}
                                disabled={!allowUpdate}
                            />
                        </GoogleMapsAutocomplete>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="country"
                            options={countries}
                            getOptionLabel={(option) => option.description || ''}
                            value={countries.find((country) => country.id === selectedCountry) || null}
                            onChange={handleCountryChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="País de Nacimiento"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedRegion && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>

                    {/* Campo de Región */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="region"
                            options={regiones}
                            getOptionLabel={(option) => option.description || ''}
                            value={regiones.find((region) => region.id === selectedRegion) || null}
                            onChange={handleRegionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Región"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedRegion && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    {/* Campo de Provincia */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="provincia"
                            options={provincias}
                            getOptionLabel={(option) => option.description || ''}
                            value={provincias.find((provincia) => provincia.id === selectedProvincia) || null}
                            onChange={handleProvinciaChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Provincia"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedProvincia && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>
                    {/* Campo de Comuna */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            id="comuna"
                            options={comunas}
                            getOptionLabel={(option) => option.description || ''}
                            value={comunas.find((comuna) => comuna.id === selectedComuna) || null}
                            onChange={handleComunaChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Comuna"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedComuna && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        {/* Selector de Sucursal */}
                        <Autocomplete
                            id="sucursal"
                            options={sucursales}
                            getOptionLabel={(option) => option.name || ''}
                            value={sucursales.find((sucursal) => sucursal.id === selectedSucursal) || null}
                            onChange={handleSucursalChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Sucursal"
                                    fullWidth
                                    required
                                    helperText={
                                        !selectedSucursal && (
                                            <span style={{ color: 'red' }}>
                                                (Campo obligatorio)
                                            </span>
                                        )
                                    }
                                />
                            )}
                            disabled={!allowUpdate}
                        />
                    </Grid>

                    <Grid item sm={12}>

                    </Grid>


                    {/* -------------------------------------------------------------------------- */}
                    <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset" variant="standard">
                            <FormLabel component="legend">Tipo Cliente</FormLabel>
                            <RadioGroup value={selectedTipo} onChange={handleTipoClienteChange}>
                                {tiposCliente.map((tipo) => (
                                    <FormControlLabel
                                        key={tipo.id}
                                        value={tipo.id}
                                        control={<Radio />}
                                        label={tipo.name}
                                        disabled={!allowUpdate}
                                    />
                                ))}
                            </RadioGroup>
                            {(selectedTipo === 2 || (customer?.rutPyme != null && customer?.rutPyme.length > 0)) && (
                                <Grid container spacing={3}>
                                    <Grid item xs={12} >
                                        <TextField
                                            fullWidth
                                            label="Rut Pyme"
                                            name="rutPyme"
                                            id="rutPyme"
                                            value={customer?.rutPyme || ""}
                                            onChange={handlePymeRutChange}
                                            disabled={!allowUpdate}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Nombre Pyme"
                                            name="nombrePyme"
                                            id="nombrePyme"
                                            value={customer?.nombrePyme || ""}
                                            onChange={handlePymeNomChange}
                                            disabled={!allowUpdate}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <FormControl component="fieldset" variant="standard">
                            <FormLabel component="legend">Clave Unica Cliente</FormLabel>
                            <RadioGroup
                                value={selectedClave}
                                onChange={handleClaveClienteChange}
                            >
                                {clavesCliente.map((clave) => (
                                    <FormControlLabel
                                        key={clave.id}
                                        value={clave.id}
                                        control={<Radio />}
                                        label={clave.name}
                                        disabled={!allowUpdate}
                                    />
                                ))}
                            </RadioGroup>

                            {(selectedClave === 2 || (customer?.claveUnica != null && customer?.claveUnica.length > 0)) && (
                                <Grid container spacing={3}>
                                    <Grid item xs={12}   >
                                        <TextField
                                            fullWidth
                                            id="claveUnica"
                                            label="Clave Unica"
                                            name="claveUnica"
                                            value={customer?.claveUnica ? customer?.claveUnica : ""}
                                            onChange={handleChange}
                                            disabled={!allowUpdate}
                                        />

                                    </Grid>
                                    <Grid item xs={12}   >
                                        <TextField
                                            fullWidth
                                            id="claveUnica"
                                            label="Re-Ingresar Clave unica"
                                            name="claveUnica"
                                            value={customer?.claveUnica
                                                ? customer?.claveUnica
                                                : ""
                                            }
                                            onChange={handleChange}
                                            disabled={!allowUpdate}
                                        />

                                    </Grid>
                                </Grid>
                            )}
                        </FormControl>
                    </Grid>


                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            id="observations"
                            label="Observaciones"
                            name="observations"
                            defaultValue={customer?.observations || ""}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            disabled={!allowUpdate}
                        />
                        <Typography variant="caption" display="block" align="right">
                            {/* Aquí se asegura que siempre se use una cadena vacía si 'customer.Observations' es undefined */}
                            {/*`${customer?.Observations ? customer.Observations.length : 0} / ${maxLength} caracteres`*/}
                        </Typography>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    {/*<Button
                        variant="contained"
                        startIcon={<AudioFileIcon />}
                        color="secondary"
                        size="large"
                        onClick={onSearchAudio}
                    >
                        Buscar Audio Llamada
                    </Button>*/}
                    {allowUpdate ?
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<GroupAddIcon />}
                            size="large"
                            onClick={handleCombinedOperation} // Utilizar la función combinada
                        >
                            Actualizar y Guardar
                        </Button>
                        :
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<SkipNext />}
                            size="large"
                            onClick={() => dispatch(setTab("2"))} // Utilizar la función combinada
                        > Continuar </Button>
                    }

                </Box>

            </Box>

        </Paper>

    );
};

export default CustomerForm;
